import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import { fetchPersonGroups, Group } from "../../api/person/groups";
import { GroupChip } from "./group-chip";

interface PersonGroupsProps {
	personId: number;
}

export const PersonGroups = ({ personId }: PersonGroupsProps) => {
	const [groups, setGroups] = useState<Group[]>([]);
	const [loading, setLoading] = useState<boolean>(true);
	const [error, setError] = useState<string | null>(null);
	const [expanded, setExpanded] = useState<boolean>(false);

	useEffect(() => {
		if (!personId) return;

		fetchPersonGroups(personId)
			.then((response) => {
				setGroups(response.results);
				setLoading(false);
			})
			.catch((err) => {
				setError(err.message);
				setLoading(false);
			});
	}, [personId]);

	if (loading) {
		return (
			<Box
				display="flex"
				justifyContent="center"
				alignItems="center"
				minHeight="100px"
				data-component="person-groups-loading-box"
			>
				<CircularProgress data-component="person-groups-loading-spinner" />
			</Box>
		);
	}

	if (error) {
		return (
			<Alert severity="error" data-component="person-groups-error-alert">
				{error}
			</Alert>
		);
	}

	if (groups.length === 0) {
		return null;
	}

	return (
		<Accordion
			expanded={expanded}
			onChange={() => setExpanded(!expanded)}
			data-component="person-groups-accordion"
		>
			<AccordionSummary
				expandIcon={
					<ExpandMoreIcon data-component="person-groups-expand-icon" />
				}
				aria-controls="person-groups-content"
				id="person-groups-header"
				data-component="person-groups-summary"
			>
				<Typography variant="h6" data-component="person-groups-title">
					LinkedIn Groups ({groups.length}){" "}
					{`- click to ${expanded ? "collapse" : "expand"}`}
				</Typography>
			</AccordionSummary>
			<AccordionDetails data-component="person-groups-details">
				<Stack
					direction="row"
					spacing={1}
					flexWrap="wrap"
					useFlexGap
					data-component="person-groups-stack"
				>
					{groups.map((group) => (
						<GroupChip key={group.id} group={group} />
					))}
				</Stack>
			</AccordionDetails>
		</Accordion>
	);
};
